/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setOnboardingContext} from '../api'

export const useMutationSetOnboardingContext = createReactQueryMutationHook('setOnboardingContext', setOnboardingContext)
